// Courses store discount as a fraction (0.15). Legacy rows hold a percent (15).
// Same rule as the front (front/utils/course.tsx discountFraction) and the
// backend finance (coursePayable). The admin form edits it as a percent.
export function discountFraction(discount?: number | null): number {
  if (!discount || discount < 0) return 0;
  return discount > 1 ? discount / 100 : discount;
}

export function discountPercent(discount?: number | null): number {
  return Math.round(discountFraction(discount) * 10000) / 100;
}
